import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

type CatalogueMarketingStyles = {
    linkColour: string
    fontWeight: string
}

export type CatalogueListTitleContentProps = {
    children: React.ReactNode
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    catalogueMarketingStyles: CatalogueMarketingStyles
    isFirstElement?: boolean
}

export const CatalogueListTitleContent = memo<CatalogueListTitleContentProps>(function CatalogueListTitleContentMemo({
    templating,
    ...props
}) {
    const TemplatedContent = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <TemplatedContent {...props} />
        </Suspense>
    )
})
CatalogueListTitleContent.displayName = "CatalogueListTitleContent"

export default connect(CatalogueListTitleContent)
